import { Stack, ContentCard, Grid, Button, Group } from '@forwardflow/ui-v2'
import {
   CheckCircle02Icon,
   ChevronRightIcon,
   // CalendarIcon,
   Building01Icon,
   ArrowLeftMdIcon,
} from '@forwardflow/icons'
import { motion } from 'framer-motion'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'

const stageMappingSteps = [
   {
      title: 'Map new leads',
      description: 'Where outreach begins.',
   },

   {
      title: 'Classify nurture',
      description: 'Define Timeline or Hot/Cold/Warm nurture.',
   },
   {
      title: 'Appointments',
      description: 'Reminders & missed follow-ups.',
   },
   {
      title: 'Stop stages',
      description: 'DNC and Closed (required), plus any others.',
   },
]

export const SummaryBeforeStaging = () => {
   const { getNextStep, getPreviousStep, onboardingData } =
      useOnboardingStoreV2()
   const { businessDetails } = onboardingData

   return (
      <Stack gap={32}>
         <ContentCard className="space-y-6">
            <Group gap={16}>
               <Group
                  className="rounded-2xl border-[0.667px] w-12 h-12 border-[rgba(0,188,125,0.3)] bg-gradient-to-br from-[rgba(0,153,102,0.3)] to-[rgba(0,150,137,0.3)]"
                  justify="center"
                  align="center"
               >
                  <CheckCircle02Icon color="#00D492" width={24} height={24} />
               </Group>
               <Stack gap={2}>
                  <p className="text-white font-medium text-xl">
                     You're all set!
                  </p>
                  <p className="text-[#99A1AF] text-sm font-medium">
                     Here's what we've configured
                  </p>
               </Stack>
            </Group>

            <Group className="p-4 rounded-xl border border-white/10 bg-white/[0.02]">
               <Group className="p-1.5 px-2.5 rounded-lg border-[0.9px] border-[#8E51FF]/30 bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30">
                  <Building01Icon width={20} color="#9F7BFF" />
               </Group>
               <Stack gap={0}>
                  <p className="text-[#99A1AF] font-medium text-xs">Business</p>
                  <p className="text-white font-medium">
                     {businessDetails?.legalBusinessName}
                  </p>
               </Stack>
            </Group>

            {/* <Group className="p-4 rounded-xl border border-white/10 bg-white/[0.02]">
               <Group className="p-1.5 px-2.5 rounded-lg border-[0.9px] border-[#8E51FF]/30 bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30">
                  <CalendarIcon width={20} color="#9F7BFF" />
               </Group>
               <Stack gap={0}>
                  <p className="text-[#99A1AF] font-medium text-xs">
                     Availablity
                  </p>
                  <p className="text-white font-medium">09:00 - 18:00</p>
               </Stack>
            </Group> */}
         </ContentCard>
         <motion.div className="space-y-4">
            <p className="text-white font-medium text-xl">
               One last thing - let's map your stages for the full Forward Flow
               experience.
            </p>
            <ContentCard>
               <Group>
                  <Stack gap={4}>
                     <p className="text-white font-medium">Stage Mapping</p>
                     <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
                        Tell Forward Flow when to start, continue, or stop
                        nurturing without changing your CRM.
                     </p>
                  </Stack>
               </Group>

               <Stack gap={16} className="mt-6">
                  <Stack gap={24} className="mb-6">
                     {stageMappingSteps.map((step, index) => (
                        <Group key={index}>
                           <div className="flex items-center justify-center w-8 h-8 rounded-lg border-[0.7] border-white bg-white/5 text-white text-sm">
                              {index + 1}
                           </div>
                           <Stack gap={0}>
                              <p className="text-white text-sm font-medium">
                                 {step.title}
                              </p>
                              <p className="text-[#99A1AF] text-sm">
                                 {step.description}
                              </p>
                           </Stack>
                        </Group>
                     ))}
                  </Stack>

                  <Grid>
                     <Grid.Col span={6}>
                        <Button
                           variant="secondary"
                           className="w-full"
                           onClick={() => getPreviousStep()}
                        >
                           <ArrowLeftMdIcon width={12} /> Back
                        </Button>
                     </Grid.Col>
                     <Grid.Col span={6}>
                        <Button
                           className="w-full"
                           onClick={() => getNextStep()}
                        >
                           Map Stages <ChevronRightIcon width={18} />
                        </Button>
                     </Grid.Col>
                  </Grid>
               </Stack>
            </ContentCard>
         </motion.div>

         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Grid>
               <Grid.Col span={12}></Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
